import {
    Button,
    chakra,
    Grid,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import {DimensionsGridHeaderRow, GridItemsSection} from "./index";
import {dimensionsKeys} from "../../../../utils";
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import {getEmptyRow} from "./GridItemsSection";

function DimensionItemModal({ modalData, isOpen, onClose, onSubmit, scope }) {
  const { t } = useTranslation("translation");
  const { organizationStructure, dimensionItems, fieldArrayName, editData } = modalData;

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    control,
    watch
  } = useForm({
    defaultValues: {
      [modalData.fieldArrayName]: [editData ? editData : getEmptyRow(organizationStructure, dimensionItems, scope)]
    }
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <chakra.form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>
            {t(`organizationQuestionnaire.${editData ? "editItemModalHeader" : "addItemsModalHeader"}`, { type: fieldArrayName })}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Grid
              templateColumns={`repeat(${(dimensionsKeys.filter(dimKey =>
                modalData.organizationStructure.dimensions[dimKey] !== null).length + 3) * 2 + (editData ? 0 : 1)}, 1fr)`}
              minWidth="700"
              maxHeight="400"
              overflow="auto"
            >
              <DimensionsGridHeaderRow
                organizationStructure={modalData.organizationStructure}
                scope={modalData.scope}
                consumptionTypesAttr={modalData.consumptionTypesAttr}
                permanentColumns={editData ?
                  [
                    t("organizationQuestionnaire.dimensionsGrid.category"),
                    t("organizationQuestionnaire.dimensionsGrid.value"),
                    t("organizationQuestionnaire.dimensionsGrid.measure")
                  ] :
                  [
                    t("organizationQuestionnaire.dimensionsGrid.category"),
                    t("organizationQuestionnaire.dimensionsGrid.value"),
                    t("organizationQuestionnaire.dimensionsGrid.measure"),
                    ""
                  ]
                }
              />
              <GridItemsSection
                modalData={modalData}
                formData={{
                  control,
                  watch,
                  register,
                  errors,
                  resetField
                }}
              />
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              {t("buttons.close")}
            </Button>
            <Button colorScheme="customScheme" type="submit">
              {t("buttons.save")}
            </Button>
          </ModalFooter>
        </chakra.form>
      </ModalContent>
    </Modal>
  );
}

export default DimensionItemModal;